import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import MailIcon from '@material-ui/icons/Mail';
import {applyCollectionRowHighlight, applyHighlightFilter, getCollectionHighlightTrProps, getHighlightPkeyFromLocation, syncCollectionFetchPage} from "utilities/avCenterHighlight";

const KIND_LABELS = {
	av_renewal_reminder: 'Upcoming reminder',
	av_renewal_invoice: 'Renewal Payment Confirmation',
	av_key_repush: 'Key Resent',
	av_portal_link: 'Payment Update Link',
	av_renewal_checkout: 'Renewal Checkout',
};

export default class AvRenewalDistributedKeys extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.emailKind = 'all';
		this.state.actionError = null;
		this.state.resendingInvoice = null;
		this.state.highlightRow = getHighlightPkeyFromLocation(props.history);
		this.rowRefs = {};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.history?.location?.hash !== this.props.history?.location?.hash) {
			const highlightRow = getHighlightPkeyFromLocation(this.props.history);
			this.setState({highlightRow}, () => this.fetchData());
		}
	}

	fetchData = async (state) => {
		syncCollectionFetchPage(this, state);
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.email_kind = this.state.emailKind;
		const highlightPkey = applyHighlightFilter(this, this.state.filter);
		this.model.filter = this.state.filter;
		this.model.search = this.state.search;
		this.setState({loading: true, highlightRow: highlightPkey || this.state.highlightRow});
		return this.model.submit(null, 'GET_RENEWAL_DISTRIBUTIONS').then((result) => {
			const rows = Array.isArray(result) ? result : [];
			this.setState({
				data: rows,
				pages: 1,
				loading: false,
			}, () => applyCollectionRowHighlight(this, rows));
			return rows;
		}).catch((err) => {
			this.setState({ loading: false, actionError: err?.message || 'Failed to load renewal emails' });
			return [];
		});
	}

	resendEmail = async (row) => {
		if (!row?.stripe_invoice_id || (!row?.can_resend && !row?.can_send_email)) return;
		this.setState({ resendingInvoice: row.stripe_invoice_id, actionError: null });
		try {
			const model = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.UPDATE);
			model.object.stripe_invoice_id = row.stripe_invoice_id;
			await model.submit(null, 'POST_RESEND_RENEWAL_EMAIL');
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Email failed' });
		} finally {
			this.setState({ resendingInvoice: null });
		}
	}

	formatKeys = (row) => {
		if (!row.keys || row.keys.length === 0) {
			return row.product_type === 'bitdefender' ? '(confirmation email - no keys)' : '-';
		}
		return row.keys.map((k) => k.activation_key || '(pending)').join(', ');
	}

	automatedEmailHref = (row) => {
		if (!row.automated_email) {
			return null;
		}
		return "/managers/automated_emails?pkey=" + row.automated_email;
	}

	render() {
		const {data, pages, limit, loading, emailKind, actionError, resendingInvoice, highlightRow} = this.state;

		const columns = [
			{
				Header: "Type",
				id: 'email_kind',
				accessor: obj => KIND_LABELS[obj.email_kind] || obj.email_kind || '-',
				minWidth: 140,
			},
			{
				Header: "Customer",
				id: 'customer',
				Cell: (props) => {
					const row = props.original;
					if (row.internal_customer_pkey) {
						return <Link to={`/customers/${row.internal_customer_pkey}#av-center`}>{row.customer_name || `#${row.internal_customer_pkey}`}</Link>;
					}
					return row.customer_name || '-';
				},
			},
			{
				Header: "Product",
				id: 'product_name',
				accessor: obj => obj.product_name || '-',
			},
			{
				Header: "Keys",
				id: 'keys',
				accessor: obj => this.formatKeys(obj),
				minWidth: 180,
			},
			{
				Header: "Emailed To",
				id: 'email_sent_to',
				accessor: obj => obj.email_sent_to || '-',
			},
			{
				Header: "Emailed At",
				id: 'email_sent_at',
				accessor: obj => obj.email_sent_at ? moment(obj.email_sent_at).format('MM/DD/YYYY h:mm A') : '-',
			},
			{
				Header: "Opened",
				id: 'email_opened',
				accessor: obj => obj.email_opened ? moment(obj.email_opened).format('MM/DD/YYYY h:mm A') : '-',
			},
			{
				Header: "Invoice",
				id: 'stripe_invoice_id',
				accessor: obj => obj.stripe_invoice_id || '-',
				minWidth: 140,
			},
			{
				Header: "",
				id: 'snapshot',
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: (props) => {
					const href = this.automatedEmailHref(props.original);
					if (!href) {
						return null;
					}
					return (
						<span>
							<Link to={href}>
								<Button color="green-meadow" size="sm" block={true}>
									<MailIcon fontSize={'small'}/>
								</Button>
							</Link>
						</span>
					);
				},
			},
			{
				Header: "",
				id: 'actions',
				Cell: (props) => {
					const row = props.original;
					const busy = resendingInvoice === row.stripe_invoice_id;
					if (row.can_resend) {
						return (
							<Button size="sm" color="primary" disabled={busy} onClick={() => this.resendEmail(row)}>
								{busy ? 'Sending…' : 'Resend email'}
							</Button>
						);
					}
					if (row.can_send_email) {
						return (
							<Button size="sm" color="primary" disabled={busy} onClick={() => this.resendEmail(row)}>
								{busy ? 'Sending…' : 'Send email'}
							</Button>
						);
					}
					if (!row.email_sent_at) {
						return <span style={{ color: '#888' }}>Awaiting keys</span>;
					}
					return <span style={{ color: '#888' }}>Not available</span>;
				},
			},
		];

		return (
			<Card>
				<CardContent>
					{actionError && (
						<div className="alert alert-danger" role="alert">{actionError}</div>
					)}
					<div className="table-bar">
						<div className="d-flex align-items-center">
							<TextField
								select
								label="Show"
								value={emailKind}
								onChange={(e) => this.setState({ emailKind: e.target.value }, () => this.fetchData())}
								margin="dense"
								style={{ minWidth: 260, marginRight: 16 }}
							>
								<MenuItem value="all">All</MenuItem>
								<MenuItem value="reminder">Upcoming reminders</MenuItem>
								<MenuItem value="invoice">Renewal payment confirmation</MenuItem>
							</TextField>
							{this.renderSearch('AV Subscriptions')}
							{this.renderHeaderRight('AV Subscriptions', columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultSorted={[{ id: 'email_sent_at', desc: true }]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						onPageChange={this.onPageChange}
						page={this.state.page}
						pageSize={limit}
						getTrProps={getCollectionHighlightTrProps(highlightRow, this.rowRefs)}
					/>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		);
	}
}
